import {useCallback, useMemo} from "react";
import {RazorpayClient} from "./razorpay-client";
import {RazorpayGlobalOptions} from "./@types/RazorpayGlobalOptions";
import {RazorpayPaymentOptions} from "./@types/RazorpayPaymentOptions";

/**
 * Custom hook to open a Razorpay payment modal without requiring a provider.
 * @param {RazorpayGlobalOptions} globalOptions - Global configuration options (e.g., key, theme, config)
 * @returns A function that accepts payment-specific fields and triggers the payment flow.
 */
export function useRazorpay(globalOptions: RazorpayGlobalOptions) {
  const isClient = useMemo(() => typeof window !== "undefined", []);
  return useCallback(
    async (paymentOptions: RazorpayPaymentOptions) => {
      if (!isClient) return;
      await RazorpayClient.openPayment({...globalOptions, ...paymentOptions});
    },
    [globalOptions]
  );
}
